var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscomAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 19.5L25 16.5L27 18.5L30 16",
    stroke: "#F1935C",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_108_1793",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 33,
    height: 26,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 33,
    height: 26,
    rx: 1,
    stroke: "#F1935C",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1_108_1793)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_108_1793",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 22,
    width: 33,
    height: 4,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 22,
    width: 33,
    height: 4,
    rx: 1,
    stroke: "#F1935C",
    strokeWidth: 3,
    mask: "url(#path-3-inside-2_108_1793)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_108_1793",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 29,
    width: 15,
    height: 3,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 29,
    width: 15,
    height: 3,
    rx: 1,
    stroke: "#F1935C",
    strokeWidth: 3,
    mask: "url(#path-4-inside-3_108_1793)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0747 25.951C14.098 25.8341 14.2006 25.75 14.3198 25.75H19.6802C19.7994 25.75 19.902 25.8341 19.9253 25.951L20.5253 28.951C20.5563 29.1057 20.438 29.25 20.2802 29.25H13.7198C13.562 29.25 13.4437 29.1057 13.4747 28.951L14.0747 25.951Z",
    stroke: "#F1935C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5H13.5",
    stroke: "#F1935C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.5H13.5",
    stroke: "#F1935C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5H13.5",
    stroke: "#F1935C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5H13.5",
    stroke: "#F1935C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.5H13.5",
    stroke: "#F1935C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19H10.5",
    stroke: "#F1935C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 7.75,
    width: 1.5,
    height: 4.5,
    stroke: "#F1935C",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.25,
    y: 10.75,
    width: 1.5,
    height: 1.5,
    stroke: "#F1935C",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 5.75,
    width: 1.5,
    height: 6.5,
    stroke: "#F1935C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscomAnalysis);
export default __webpack_public_path__ + "static/media/discomAnalysis.9951e3898074efc20db54d17f2bd81f1.svg";
export { ForwardRef as ReactComponent };